// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-50f94f26]{width:90px}.badge-type[data-v-50f94f26]{min-width:120px;padding:8px 12px}@media screen and (max-width:767px){.badge-type[data-v-50f94f26]{min-width:auto}}.badge-inland[data-v-50f94f26]{background-color:#3184b2}.badge-international[data-v-50f94f26]{background-color:#efad02}.text-xl[data-v-50f94f26]{font-size:20px}.border-1[data-v-50f94f26]{width:1px;height:22px;background:#000}", ""]);
// Exports
module.exports = exports;
